// extracted by mini-css-extract-plugin
export default {"container":"artwork-sent-to-studio_container__yxuBX"};